import React from 'react';
import PropTypes from 'prop-types';
import { Empty } from 'antd';
import Wait4Me from '../../../../components/Wait4Me';
import HiGoMeLoColors from '../../../common/components/HiGoMeLoColors';
import styled, { CardView, LoadingWrapper } from '../styled';
import { toLower } from '../../../../util/lodashlike';
import { convertISOToUTCDateFormat } from '../../../../util/timezone';
const { plrtb } = styled;

const defaultProps = {
  alertPartyIdentity: { isLoading: false, data: null }
};

const CustomerIdentity = ({ alertPartyIdentity = {} }) => {
  const [INDIVIDUAL, CORPORATE] = ['Individual', 'Corporate'];
  const { isLoading, data } = alertPartyIdentity;
  const riskRating = (risk) =>
    toLower(risk) === 'high' && (
      <span style={{ background: HiGoMeLoColors(risk) }} className="riskTablet">
        {risk}
      </span>
    );

  const commonInfo = [
    { name: 'Bank Relationship', key: 'yearsOfRelationship' },
    { name: 'Adverse Media', key: 'adverseMedia' },
    { name: 'PEP', key: 'isPep' },
    { name: 'Special Attention Flag', key: 'specialAttentionFlag' },
    { name: 'Adverse News Flag', key: 'adverseNewsFlag' },
    { name: 'Source of Income', key: 'sourceOfFunds' },
    { name: 'Customer Income', key: 'annualRevenueOrIncome' }
  ];

  const individual = [
    { name: 'Individual Name', key: 'partyName' },
    { name: 'Age', key: 'age' },
    { name: 'Risk Status', key: 'riskStatus' },
    { name: 'Occupation', key: 'occupation', tablet: 'occupationRisk' },
    {
      name: 'Country of Residence',
      key: 'residenceOperationCountry',
      tablet: 'residenceOperationCountryRisk'
    },
    ...commonInfo,
    { name: 'Nationality', key: 'citizenshipCountry' },
    { name: 'ID Expiry Date', key: 'idExpiryDate' }
  ];

  const corporate = [
    { name: 'Corporate Name', key: 'partyName' },
    {
      name: 'Business Activity',
      key: 'businessActivity',
      tablet: 'businessActivityRisk'
    },
    { name: 'Year of Incorporation', key: 'yearsOfIncorporation' },
    {
      name: 'Country of Operation',
      key: 'residenceOperationCountry',
      tablet: 'residenceOperationCountryRisk'
    },
    {
      name: 'Country of Incorporation',
      key: 'birthIncorporationCountry',
      tablet: 'birthIncorporationCountryRisk'
    },
    ...commonInfo,
    { name: 'Nationality', key: 'birthIncorporationCountry' },
    { name: 'ID Expiry Date', key: 'idExpiryDate' }
  ];

  const formatData = (key, value) => {
    if (
      key === 'isPep' ||
      key === 'specialAttentionFlag' ||
      key === 'adverseMedia' ||
      key === 'adverseNewsFlag'
    ) {
      return value ? 'Yes' : 'No';
    } else if (key === 'idExpiryDate') {
      return value ? convertISOToUTCDateFormat(value) : '-';
    } else {
      return value || '-';
    }
  };

  const fulledValuesWithHtml = (dataList = [], resData = {}) => (
    <div className="contant">
      {' '}
      {dataList.reduce(
        (acc, { key, name, tablet }) =>
          key === dataList[0]?.key
            ? acc
            : [
                ...acc,
                <>
                  {' '}
                  <p>{name}</p>{' '}
                  <span>
                    {formatData(key, resData[key])}
                    {resData[tablet] && riskRating(resData?.riskRating)}{' '}
                  </span>{' '}
                </>
              ],
        [
          <>
            <p>{dataList[0]['name']}</p>{' '}
            <span>
              <b>{resData[dataList[0]?.key] || '-'} </b>
            </span>
          </>
        ]
      )}{' '}
    </div>
  );

  return (
    <>
      <CardView>
        <header style={plrtb}>
          {' '}
          <b> Customer Identity </b>{' '}
        </header>

        {isLoading && (
          <LoadingWrapper>
            {' '}
            <Wait4Me />{' '}
          </LoadingWrapper>
        )}
        {!isLoading && JSON.stringify(data) === '{}' && (
          <LoadingWrapper>
            {' '}
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />{' '}
          </LoadingWrapper>
        )}

        {
          /* Individual */
          INDIVIDUAL === data?.customerType &&
            fulledValuesWithHtml(individual, data)
        }

        {
          /* Corporate */
          CORPORATE === data?.customerType &&
            fulledValuesWithHtml(corporate, data)
        }
      </CardView>
    </>
  );
};

CustomerIdentity.defaultProps = defaultProps;
CustomerIdentity.propTypes = {
  alertPartyIdentity: PropTypes.object
};
export default CustomerIdentity;
